// extracted by mini-css-extract-plugin
export var aboveInput = "_m8-0";
export var actionButton = "_m8-5";
export var actionButtonContainer = "_m8-1";
export var actionIcon = "_m8-6";
export var aiInfoContainer = "_m8-2";
export var attachmentWrapper = "_m8-7";
export var bold = "_m8-3";
export var checkIcon = "_m8-8";
export var clickingRecipientBar = "_m8-11";
export var commentThreadSwitch = "_m8-a";
export var draftImage = "_m8-b";
export var draftImageContainer = "_m8-c";
export var draftImages = "_m8-e";
export var editButton = "_m8-g";
export var editor = "_m8-f";
export var editorContainer = "_m8-y";
export var editorErrorTooltipWrapper = "_m8-9";
export var headerDivider = "_m8-h";
export var icon = "_m8-i";
export var info = "_m8-j";
export var internal = "_m8-n";
export var internalDivider = "_m8-k";
export var internalMessage = "_m8-l";
export var messageInputCard = "_m8-m";
export var messageInputForm = "_m8-o";
export var messageInputFormInternal = "_m8-p";
export var options = "_m8-q";
export var publicMessageCustomer = "_m8-s";
export var publicMessageMerchant = "_m8-r";
export var removeImageButton = "_m8-d";
export var replyButtons = "_m8-t";
export var showSignatureButton = "_m8-u";
export var spinner = "_m8-v";
export var verticalButtonDivider = "_m8-4";
export var visibilitySelector = "_m8-w";
export var warning = "_m8-x";
export var wrappingText = "_m8-z";
export var writingInternalNoteTopBorder = "_m8-10";